// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function admin_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
  if (email.TAG === /* Ok */0) {
    var first_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "first_name"), null));
    if (first_name.TAG === /* Ok */0) {
      var last_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_name"), null));
      if (last_name.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  email: email._0,
                  first_name: first_name._0,
                  last_name: last_name._0
                }
              };
      }
      var e = last_name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".last_name" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = first_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".first_name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = email._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".email" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var role = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "role"), null));
  if (role.TAG === /* Ok */0) {
    var admin_info = admin_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "admin_info"), null));
    if (admin_info.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                role: role._0,
                admin_info: admin_info._0
              }
            };
    }
    var e = admin_info._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".admin_info" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = role._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".role" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  admin_info_decode ,
  t_decode ,
  
}
/* No side effect */
